export default __webpack_public_path__ + "static/Nox5-59d90e0d69624938cf42168727d5593b.png";